import PropTypes from "prop-types";
import React from "react";

const SectionTitleSeven = ({
  titleText,
  subTitleText,
  spaceClass,
  borderClass,
  titleStyle,
  subTitleStyle,
  titlepositionClass,
  subTitlepositionClass
}) => {
  return (
    <div className={`section-title ${borderClass ? borderClass : ""} ${spaceClass ? spaceClass : ""}`}>
      {titleText && (
        <h2 className={titlepositionClass} style={titleStyle} dangerouslySetInnerHTML={{ __html: titleText }}></h2>
      )}
      {subTitleText && (
        <p className={subTitlepositionClass} style={subTitleStyle} dangerouslySetInnerHTML={{ __html: subTitleText }}></p>
      )}

    </div>
  );
};

SectionTitleSeven.propTypes = {
  borderClass: PropTypes.string,
  positionClass: PropTypes.string,
  spaceClass: PropTypes.string,
  subTitleText: PropTypes.string,
  titleText: PropTypes.string
};

export default SectionTitleSeven;
